import type { RakutenCoupon } from '../api/rakutenCoupons';

export type MockCouponScenario = 'multiple' | 'empty';

const MOCK_COUPONS: ReadonlyArray<RakutenCoupon> = Object.freeze([
  {
    id: 101,
    title: 'LINE限定 20% OFF',
    usage_conditions: '22,000円以上のご購入で利用可能',
    description: 'LINEのお友だち限定クーポンです',
    discount_type: 'percentage',
    discount_value: 20,
    start_at: '2026-08-17T00:00:00Z',
    end_at: '2026-08-31T14:59:00Z',
    image_url: null,
    destination_url: 'https://coupon.rakuten.co.jp/detail/mock-percentage',
  },
  {
    id: 102,
    title: '2,000円OFFクーポン',
    usage_conditions: '対象商品で利用可能',
    description: '対象商品にお使いいただけます',
    discount_type: 'fixed_amount',
    discount_value: 2000,
    start_at: '2026-08-17T00:00:00Z',
    end_at: '2026-09-07T14:59:00Z',
    image_url: null,
    destination_url: 'https://coupon.rakuten.co.jp/detail/mock-fixed',
  },
  {
    id: 103,
    title: '送料無料クーポン',
    usage_conditions: '通常購入で利用可能',
    description: 'この機会に気になるアイテムをお試しください',
    discount_type: 'free_shipping',
    discount_value: null,
    start_at: '2026-08-17T00:00:00Z',
    end_at: '2026-09-14T14:59:00Z',
    image_url: null,
    destination_url: 'https://coupon.rakuten.co.jp/detail/mock-shipping',
  },
]);

export function getMockCoupons(scenario: MockCouponScenario): RakutenCoupon[] {
  if (scenario === 'empty') return [];
  return MOCK_COUPONS.map((coupon) => ({ ...coupon }));
}
